"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCalendarUtilities = void 0;
var bc_date_constants_1 = require("./bc-date-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var common_constants_2 = require("../../../common/constants/common-constants");
var bc_input_constants_1 = require("../../atoms/bc-input/bc-input-constants");
var bc_input_constants_2 = require("../../atoms/bc-input/bc-input-constants");
var bc_input_constants_3 = require("../../atoms/bc-input/bc-input-constants");
var bc_input_constants_4 = require("../../atoms/bc-input/bc-input-constants");
var bc_input_constants_5 = require("../../atoms/bc-input/bc-input-constants");
var bc_date_constants_2 = require("./bc-date-constants");
var BcCalendarUtilities = (function () {
    function BcCalendarUtilities() {
    }
    BcCalendarUtilities.prototype.topBarSingleMonth = function () {
        return "<div class=\"".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS, "\">\n    <em class=\"").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.PREV_CLASS, "\">arrow2-left</em>\n    <h6 class=\"").concat(bc_date_constants_1.BcDateConstants.MONTH_NAME_CLASS, "\"></h6> \n    <em class=\"").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.NEXT_CLASS, "\">arrow2-right</em>\n    </div>");
    };
    BcCalendarUtilities.prototype.filterSimple = function (text) {
        return "<button class = \"".concat(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER, "\">\n      <em class='").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "'> calendar </em>        \n      <p class='").concat(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER, "-text'>").concat(text, "</p>\n      <em class='").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "'></em>\n    </button>");
    };
    BcCalendarUtilities.prototype.topBarSingleMonthSplitSelector = function () {
        return "<div class=\"".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS, "\"><em class=\"").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " \n    ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS).concat(bc_date_constants_1.BcDateConstants.PREV_CLASS, "\">arrow2-left</em>\n    <h6 class=\"").concat(bc_date_constants_1.BcDateConstants.MONTH_NAME_CLASS, "\"></h6><em class=\"").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, "\n    ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.NEXT_CLASS, "\">arrow2-right</em>\n    <em class=\"").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.PREV_CLASS, "\">arrow2-left</em><h6 class=\"").concat(bc_date_constants_1.BcDateConstants.YEAR_CLASS, "\">\n    </h6><em class=\"").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.NEXT_CLASS, "\">arrow2-right</em></div>");
    };
    BcCalendarUtilities.prototype.topBarMobileScrollable = function () {
        return "<div class=\"".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS, "\">\n    <h6 class=\"").concat(bc_date_constants_1.BcDateConstants.MONTH_NAME_CLASS, "\"></div>");
    };
    BcCalendarUtilities.prototype.getOneSimpleMonth = function (referenceMonth, referenceYear) {
        return {
            month: referenceMonth,
            year: referenceYear,
        };
    };
    BcCalendarUtilities.prototype.getDisplayedMonthElement = function (topBar) {
        var innerHTML = "\n    ".concat(topBar, "\n    <div class='").concat(bc_date_constants_1.BcDateConstants.WEEK_CLASS, "'></div>\n    <div class='").concat(bc_date_constants_1.BcDateConstants.DAYS_CLASS, "'></div>");
        var elem = document.createElement('div');
        elem.classList.add(bc_date_constants_1.BcDateConstants.DISPLAYED_CALENDARS_CLASS);
        elem.innerHTML = innerHTML;
        return elem;
    };
    BcCalendarUtilities.prototype.getTwelveScrollableMonths = function (referenceMonth, referenceYear) {
        var months = [];
        for (var i = referenceMonth - bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N6; i <= referenceMonth + bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N6; i++) {
            var tempDate = new Date(referenceYear, i, 1);
            var month = {
                month: tempDate.getMonth(),
                year: tempDate.getFullYear(),
            };
            months.push(month);
        }
        return months;
    };
    BcCalendarUtilities.prototype.getTwoRangeMonths = function (referenceMonth, referenceYear) {
        var months = [];
        var tempDate = new Date();
        tempDate.setMonth(referenceMonth, 1);
        tempDate.setFullYear(referenceYear);
        for (var i = referenceMonth; i <= referenceMonth + 1; i++) {
            tempDate.setMonth(i);
            var month = {
                month: tempDate.getMonth(),
                year: tempDate.getFullYear(),
            };
            months.push(month);
        }
        return months;
    };
    BcCalendarUtilities.prototype.goToPreviousMonth = function (displayedMonth) {
        displayedMonth.month--;
        if (displayedMonth.month < 0) {
            displayedMonth.month = 11;
            displayedMonth.year--;
        }
    };
    BcCalendarUtilities.prototype.getCalendarSelectMonthOrYear = function () {
        return "\n    <div class='".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS, "'>\n    <em class='").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "\n    ").concat(bc_date_constants_1.BcDateConstants.PREV_CLASS, "'>arrow2-left</em>\n    <h6 class='").concat(bc_date_constants_1.BcDateConstants.CURRENT_SELECTION_CLASS, "'>\n    </h6><em class='").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, "\n    ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "\n    ").concat(bc_date_constants_1.BcDateConstants.NEXT_CLASS, "'>arrow2-right</em></div>\n    <div class='").concat(bc_date_constants_1.BcDateConstants.MONTHS_OR_YEARS_CLASS, "'></div>");
    };
    BcCalendarUtilities.prototype.getRangeCalendarButtons = function () {
        return "<div class=\"".concat(bc_date_constants_1.BcDateConstants.UPPPER_BTNS_CLASS, "\"></div>");
    };
    BcCalendarUtilities.prototype.getContentFixedContainer = function () {
        return " <div class='from-to-container'>\n   <div class='".concat(bc_date_constants_1.BcDateConstants.DATES_CLASS, "'><p class='").concat(common_constants_1.BcCommonConstants.SMALL, "'>Desde</p><p class='").concat(bc_date_constants_1.BcDateConstants.FROM_CLASS, "'>dd/mm/aa</p></div>\n   <div class='").concat(bc_date_constants_1.BcDateConstants.DATES_CLASS, "'><p class='").concat(common_constants_1.BcCommonConstants.SMALL, "'>Hasta</p><p class='").concat(bc_date_constants_1.BcDateConstants.TO_CLASS, "'>dd/mm/aa</p></div>\n   </div>\n   <button class='").concat(common_constants_1.BcCommonConstants.BC_BTN_CLASS, " ").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.CONFIRM_CLASS, "\n   ").concat(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS, "' disabled='true'>Aceptar</button>\n   <em class='").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, "  ").concat(bc_date_constants_1.BcDateConstants.CANCEL_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.BTN_X_CLASS, "'>error</em>");
    };
    BcCalendarUtilities.prototype.confirmBtnsString = function (language) {
        var textCancel = language == 'es' ? 'Cancelar' : 'Cancel';
        var textAccept = language == 'es' ? 'Aceptar' : 'Accept';
        var textReset = language == 'es' ? 'Restablecer' : 'Reset';
        return "\n              <a ".concat(common_constants_1.BcCommonConstants.BC_LINK_CLASS, " typeLink='").concat(bc_date_constants_1.BcDateConstants.TYPE_LINK, "' \n              class= \"bc-col-6 ").concat(bc_date_constants_1.BcDateConstants.RESTORE_CLASS, "\"> ").concat(textReset, " </a>                               \n              <button class='").concat(common_constants_1.BcCommonConstants.BC_BTN_CLASS, " bc-col-3 ").concat(common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS, " \n              ").concat(bc_date_constants_1.BcDateConstants.CANCEL_CLASS, " ").concat(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS, "'>").concat(textCancel, "</button>\n              <button class='").concat(common_constants_1.BcCommonConstants.BC_BTN_CLASS, " bc-col-3 ").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, " \n              ").concat(bc_date_constants_1.BcDateConstants.CONFIRM_CLASS, " ").concat(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS, "'>").concat(textAccept, "</button>\n            ");
    };
    BcCalendarUtilities.prototype.confirmBtnString = function (text) {
        return "<button class='".concat(common_constants_1.BcCommonConstants.BC_BTN_CLASS, " ").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.CONFIRM_CLASS, "'>").concat(text, "</button>");
    };
    BcCalendarUtilities.prototype.createARangeButton = function (days, text, language) {
        var lastText = language == 'es' ? 'últimos' : 'Last';
        var daysText = language == 'es' ? 'días' : 'days';
        var btn = document.createElement('button');
        btn.classList.add(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER);
        if (text == null) {
            btn.innerHTML = "<em class='".concat(common_constants_1.BcCommonConstants.ICONS_CLASS, "\n        ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "'></em>\n        <p class='").concat(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER, "-text'>").concat(lastText, " ").concat(days, " ").concat(daysText, "</p>\n        <em class='").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "'></em>");
        }
        else {
            btn.innerHTML = "<em class='".concat(common_constants_1.BcCommonConstants.ICONS_CLASS, "\n        ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "'></em>\n        <p class='").concat(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER, "-text'>").concat(text, "</p>\n        <em class='").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "'></em>");
        }
        btn.setAttribute('value', days + '');
        return btn;
    };
    BcCalendarUtilities.prototype.addWeekDays = function (week, language) {
        week.innerHTML = '';
        this.getListWeekByLanguage(language).forEach(function (day) {
            var textDay = document.createElement('p');
            textDay.classList.add(common_constants_1.BcCommonConstants.SMALL, common_constants_1.BcCommonConstants.TEXT_GRAY);
            textDay.textContent = day;
            week.appendChild(textDay);
        });
    };
    BcCalendarUtilities.prototype.goToNextMonth = function (displayedMonth) {
        displayedMonth.month++;
        if (displayedMonth.month > bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11) {
            displayedMonth.month = 0;
            displayedMonth.year++;
        }
    };
    BcCalendarUtilities.prototype.validateLeapYear = function (year) {
        return year % bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N100 === 0
            ? year % bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N400 === 0
            : year % bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N4 === 0;
    };
    BcCalendarUtilities.prototype.compareDates = function (date1, date2) {
        return date1.getTime() - date2.getTime();
    };
    BcCalendarUtilities.prototype.getMonthIndex = function (month, language) {
        return this.getListMonthByLanguage(language).findIndex(function (currentValue) { return currentValue.toLowerCase() === month.toLowerCase(); });
    };
    BcCalendarUtilities.prototype.getMonthShorIndex = function (month, language) {
        return this.getListMonthShortByLanguage(language).findIndex(function (currentValue) { return currentValue.toLowerCase() === month.toLowerCase(); });
    };
    BcCalendarUtilities.prototype.getClickedDateYear = function (elem) {
        var monthTextElement = elem.querySelectorAll(common_constants_1.BcCommonConstants.H6_TAG);
        return monthTextElement[1]
            ? monthTextElement[1].textContent
            : monthTextElement[0].textContent.split(' ')[1];
    };
    BcCalendarUtilities.prototype.getNumberOfDays = function (numberMonth, year) {
        if (bc_date_constants_1.BcDateConstants.LONG_MONTHS.includes(numberMonth)) {
            return bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N31;
        }
        else if (bc_date_constants_1.BcDateConstants.SHORT_MONTHS.includes(numberMonth)) {
            return bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N30;
        }
        else {
            return this.validateLeapYear(year) ? bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N29 : bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N28;
        }
    };
    BcCalendarUtilities.prototype.getClickedDateMonth = function (elem) {
        var monthTextElement = elem.querySelector('h6');
        return monthTextElement.textContent.split(' ')[0];
    };
    BcCalendarUtilities.prototype.configMonthElement = function (topBar, monthInfo, language) {
        var element = this.getDisplayedMonthElement(topBar);
        var month = element.querySelector(".".concat(bc_date_constants_1.BcDateConstants.DAYS_CLASS));
        var year = element.querySelector(".".concat(bc_date_constants_1.BcDateConstants.YEAR_CLASS));
        var monthName = element.querySelector(".".concat(bc_date_constants_1.BcDateConstants.MONTH_NAME_CLASS));
        var week = element.querySelector(".".concat(bc_date_constants_1.BcDateConstants.WEEK_CLASS));
        if (year) {
            monthName.textContent = this.getListMonthByLanguage(language)[monthInfo.month];
            year.textContent = monthInfo.year + '';
        }
        else {
            monthName.textContent = this.getListMonthByLanguage(language)[monthInfo.month] + ' ' + monthInfo.year;
        }
        this.addWeekDays(week, language);
        month.innerHTML = '';
        var tempDate = new Date();
        tempDate.setFullYear(monthInfo.year);
        tempDate.setMonth(monthInfo.month, 1);
        var emptyDays = tempDate.getDay();
        return {
            emptyDays: emptyDays,
            month: month,
            tempDate: tempDate,
            element: element,
        };
    };
    BcCalendarUtilities.prototype.maxScreenWidth = function () {
        if (screen.width <= bc_date_constants_1.BcDateConstants.MAX_SCREEN_WIDTH) {
            return true;
        }
        else {
            return false;
        }
    };
    BcCalendarUtilities.prototype.holidays = function (dayIterator, monthInfo, day, holidays) {
        for (var _i = 0, holidays_1 = holidays; _i < holidays_1.length; _i++) {
            var date = holidays_1[_i];
            if (dayIterator == date.day && monthInfo.month == date.month - common_constants_2.COMMON_CONSTANTS_NUMBERS.N1) {
                var holiday = document.createElement('div');
                holiday.classList.add(bc_date_constants_1.BcDateConstants.HOLIDAY_CLASS);
                day.appendChild(holiday);
            }
        }
    };
    BcCalendarUtilities.prototype.holidaysMap = function (holidays) {
        return holidays.map(function (holiday) {
            return {
                month: holiday.month,
                day: holiday.day
            };
        });
    };
    BcCalendarUtilities.prototype.focusListeners = function (elem) {
        elem.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUS, function (event) {
            elem.classList.add(bc_date_constants_1.BcDateConstants.OUTLINE_CLASS);
        });
        elem.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function (event) {
            elem.classList.remove(bc_date_constants_1.BcDateConstants.OUTLINE_CLASS);
        });
    };
    BcCalendarUtilities.prototype.setDayAttribute = function (day, monthInfo) {
        day.setAttribute(bc_date_constants_1.BcDateConstants.ID, "".concat(bc_date_constants_1.BcDateConstants.ID_DAY).concat(day.textContent));
        day.setAttribute(bc_date_constants_1.BcDateConstants.ID_MONTH, "".concat(monthInfo.month));
        day.setAttribute(bc_date_constants_1.BcDateConstants.ID_YEAR, "".concat(monthInfo.year));
    };
    BcCalendarUtilities.prototype.accessibilityYears = function (event, element, myMap, calendarBehavior) {
        if (myMap.has(event.key)) {
            this.pageUpPageDownAndAltYears(myMap, event, element, calendarBehavior);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
            this.moveYears(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
            this.moveYears(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
            this.moveYears(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N4, calendarBehavior);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            this.moveYears(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N4, calendarBehavior);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
            this.moveToInitOrFinalYear(true, calendarBehavior);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
            this.moveToInitOrFinalYear(false, calendarBehavior);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
            calendarBehavior.selectMonth(parseInt(element.getAttribute(bc_date_constants_1.BcDateConstants.MONTH_NUMBER)), calendarBehavior.displayedMonths[0]);
        }
    };
    BcCalendarUtilities.prototype.pageUpPageDownAndAltYears = function (myMap, event, element, calendarBehavior) {
        myMap.set(event.key, true);
        if (!myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.moveYears(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12, calendarBehavior);
        }
        if (!myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.moveYears(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12, calendarBehavior);
        }
        if (myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.moveYears(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N120, calendarBehavior);
        }
        if (myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.moveYears(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N120, calendarBehavior);
        }
    };
    BcCalendarUtilities.prototype.moveYears = function (year, howMany, calendarBehavior) {
        var _a, _b, _c;
        var getValues = calendarBehavior.yearGroupName.textContent.split('-');
        var init = parseInt(getValues[0]);
        var final = parseInt(getValues[1]);
        var next = parseInt(year.textContent) + howMany;
        if (next > final) {
            var jumps = Math.ceil((next - final) / bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12);
            calendarBehavior.displayedMonths[0].year += jumps * bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12;
            calendarBehavior.yearGroup = [
                calendarBehavior.displayedMonths[0].year - bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11,
                calendarBehavior.displayedMonths[0].year,
            ];
            calendarBehavior.setElementsWithCalendarState(calendarBehavior.displayedMonths[0]);
            (_a = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_YEAR).concat(next))) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else if (next < init) {
            var jumps = -Math.ceil((init - next) / bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12);
            calendarBehavior.displayedMonths[0].year += jumps * bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12;
            calendarBehavior.yearGroup = [
                calendarBehavior.displayedMonths[0].year - bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11,
                calendarBehavior.displayedMonths[0].year,
            ];
            calendarBehavior.setElementsWithCalendarState(calendarBehavior.displayedMonths[0]);
            (_b = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_YEAR).concat(next))) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else {
            (_c = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_YEAR).concat(next))) === null || _c === void 0 ? void 0 : _c.focus();
        }
    };
    BcCalendarUtilities.prototype.moveToInitOrFinalYear = function (goToinit, calendarBehavior) {
        var _a, _b;
        var getValues = calendarBehavior.yearGroupName.textContent.split('-');
        var init = getValues[0];
        var final = getValues[1];
        if (goToinit) {
            (_a = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_YEAR).concat(init))) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_YEAR).concat(final))) === null || _b === void 0 ? void 0 : _b.focus();
        }
    };
    BcCalendarUtilities.prototype.accessibilityMonths = function (event, element, myMap, calendarBehavior) {
        if (myMap.has(event.key)) {
            this.pageUpPageDownAndAltMonths(myMap, event, element, calendarBehavior);
        }
        else {
            this.keyEventsMonths(event, element, calendarBehavior);
        }
    };
    BcCalendarUtilities.prototype.keyEventsMonths = function (event, element, calendarBehavior) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
            this.moveMonths(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
            this.moveMonths(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
            this.moveMonths(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N4);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            this.moveMonths(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N4);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
            this.moveToMonths(0);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
            this.moveToMonths(bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
            calendarBehavior.selectMonth(parseInt(element.getAttribute(bc_date_constants_1.BcDateConstants.MONTH_NUMBER)), calendarBehavior.displayedMonths[0]);
        }
    };
    BcCalendarUtilities.prototype.pageUpPageDownAndAltMonths = function (myMap, event, element, calendarBehavior) {
        myMap.set(event.key, true);
        if (!myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
            this.moveMonths(element, 0);
        }
        if (!myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
            this.moveMonths(element, 0);
        }
        if (myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N10, calendarBehavior);
            this.moveMonths(element, 0);
        }
        if (myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N10, calendarBehavior);
            this.moveMonths(element, 0);
        }
    };
    BcCalendarUtilities.prototype.moveMonths = function (month, howMany) {
        var _a;
        var next = (parseInt(month.getAttribute(bc_date_constants_1.BcDateConstants.MONTH_NUMBER)) + howMany).toString();
        (_a = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_MONTH).concat(next))) === null || _a === void 0 ? void 0 : _a.focus();
    };
    BcCalendarUtilities.prototype.moveToMonths = function (monthNumber) {
        var _a;
        (_a = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_MONTH).concat(monthNumber))) === null || _a === void 0 ? void 0 : _a.focus();
    };
    BcCalendarUtilities.prototype.keyReader = function (element, calendarBehavior, dayEnabled) {
        var _this = this;
        var myMap = new Map([
            [common_constants_1.BcCommonConstants.KEY_EVENT_ALT, false],
            [common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN, false],
            [common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_UP, false],
        ]);
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (calendarBehavior.calendarState == bc_date_constants_1.BcDateConstants.STATE_YEARS) {
                _this.accessibilityYears(event, element, myMap, calendarBehavior);
            }
            else if (calendarBehavior.calendarState == bc_date_constants_1.BcDateConstants.STATE_MONTHS) {
                _this.accessibilityMonths(event, element, myMap, calendarBehavior);
            }
            else {
                _this.accessibilityDays(event, element, myMap, dayEnabled, calendarBehavior);
            }
        });
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (myMap.has(event.key)) {
                myMap.set(event.key, false);
            }
        });
    };
    BcCalendarUtilities.prototype.accessibilityDays = function (event, element, myMap, dayEnabled, calendarBehavior) {
        if (myMap.has(event.key)) {
            this.pageUpPageDownAndAltDays(myMap, event, element, calendarBehavior);
        }
        else {
            this.keyEventsDays(event, element, dayEnabled, calendarBehavior);
        }
    };
    BcCalendarUtilities.prototype.keyEventsDays = function (event, element, dayEnabled, calendarBehavior) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
            this.moveDay(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
            this.moveDay(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
            this.moveDay(element, -bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N7);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            this.moveDay(element, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N7);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
            this.moveToDay(bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
            this.moveToDay(this.getNumberOfDays(calendarBehavior.displayedMonths[0].month, calendarBehavior.displayedMonths[0].year));
        }
        else if ((event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) &&
            dayEnabled) {
            calendarBehavior.selectDateByButton();
        }
    };
    BcCalendarUtilities.prototype.pageUpPageDownAndAltDays = function (myMap, event, element, calendarBehavior) {
        myMap.set(event.key, true);
        if (!myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            this.moveDay(element, 0);
        }
        if (!myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            this.moveDay(element, 0);
        }
        if (myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], -1, calendarBehavior);
            this.moveDay(element, 0);
        }
        if (myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_ALT) && myMap.get(common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], 1, calendarBehavior);
            this.moveDay(element, 0);
        }
    };
    BcCalendarUtilities.prototype.moveDay = function (day, howMany) {
        var _a;
        var next = (parseInt(day.textContent) + howMany).toString();
        (_a = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_DAY).concat(next))) === null || _a === void 0 ? void 0 : _a.focus();
    };
    BcCalendarUtilities.prototype.moveToDay = function (dayNumber) {
        var _a;
        (_a = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_DAY).concat(dayNumber))) === null || _a === void 0 ? void 0 : _a.focus();
    };
    BcCalendarUtilities.prototype.displaceYears = function (displayedMonth, years, calendarBehavior) {
        displayedMonth.year += years;
        calendarBehavior.setElementsWithCalendarState(displayedMonth);
    };
    BcCalendarUtilities.prototype.getListMonthByLanguage = function (language) {
        if (language.toLowerCase() == 'en') {
            return bc_date_constants_1.BcDateConstants.MONTHS_TEXT_ENGLISH;
        }
        else {
            return bc_date_constants_1.BcDateConstants.MONTHS_TEXT;
        }
    };
    BcCalendarUtilities.prototype.getListMonthShortByLanguage = function (language) {
        if (language.toLowerCase() == 'en') {
            return bc_date_constants_1.BcDateConstants.MONTHS_TEXT_SHORT_ENGLISH;
        }
        else {
            return bc_date_constants_1.BcDateConstants.MONTHS_TEXT_SHORT;
        }
    };
    BcCalendarUtilities.prototype.getListWeekByLanguage = function (language) {
        if (language.toLowerCase() == 'en') {
            return bc_date_constants_1.BcDateConstants.WEEK_SHORT_ENGLISH;
        }
        else {
            return bc_date_constants_1.BcDateConstants.WEEK_SHORT;
        }
    };
    BcCalendarUtilities.prototype.getLocalesByLanguage = function (language) {
        if (language.toLowerCase() == 'en') {
            return 'en-US';
        }
        else {
            return 'es-CO';
        }
    };
    BcCalendarUtilities.prototype.errorInputUpdateClass = function (input, errorText) {
        if (!input.classList.contains(bc_input_constants_2.INPUT_ERROR_CLASS)) {
            input.classList.add(bc_input_constants_2.INPUT_ERROR_CLASS);
            var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            var length_1 = input.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
            var icon = input.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[length_1 - common_constants_2.COMMON_CONSTANTS_NUMBERS.N1];
            if (input.value !== '' && input.type !== 'date') {
                input.classList.add(bc_date_constants_2.ACTIVE_CLASS_INPUT);
            }
            icon.classList.add(bc_input_constants_5.INPUT_BUTTON_ICON_CLASS);
            icon.innerHTML = bc_input_constants_4.BC_INPUT_REMOVE_ICON;
            span.textContent = errorText;
        }
        if (input.classList.contains(bc_input_constants_1.INPUT_SUCCESS_CLASS)) {
            input.classList.remove(bc_input_constants_1.INPUT_SUCCESS_CLASS);
            input.classList.add(bc_input_constants_2.INPUT_ERROR_CLASS);
            var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            span.textContent = errorText;
        }
    };
    BcCalendarUtilities.prototype.successInputUpdateClass = function (input, icon, successText) {
        if (input.classList.contains(bc_input_constants_2.INPUT_ERROR_CLASS)) {
            input.classList.remove(bc_input_constants_2.INPUT_ERROR_CLASS);
            input.classList.add(bc_input_constants_1.INPUT_SUCCESS_CLASS);
            var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            span.textContent = successText;
            icon.innerHTML = bc_input_constants_3.BC_INPUT_SUCCESSFUL_ICON;
        }
        else {
            input.classList.add(bc_input_constants_1.INPUT_SUCCESS_CLASS);
            var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            span.textContent = successText;
            icon.innerHTML = bc_input_constants_3.BC_INPUT_SUCCESSFUL_ICON;
        }
    };
    BcCalendarUtilities.prototype.removeClassInput = function (input) {
        if (input.classList.contains(bc_input_constants_2.INPUT_ERROR_CLASS)) {
            input.classList.remove(bc_input_constants_2.INPUT_ERROR_CLASS);
        }
        if (input.classList.contains(bc_input_constants_1.INPUT_SUCCESS_CLASS)) {
            input.classList.remove(bc_input_constants_1.INPUT_SUCCESS_CLASS);
        }
    };
    BcCalendarUtilities.prototype.formatDate = function (month, day, year, format) {
        var z = {
            M: month,
            d: day,
        };
        format = format.replace(/(M+|d+|h+|m+|s+)/g, function (v) {
            return ((v.length > common_constants_2.COMMON_CONSTANTS_NUMBERS.N1 ? "0" : "") + z[v.slice(-common_constants_2.COMMON_CONSTANTS_NUMBERS.N1)]);
        });
        return format.replace(/(y+)/g, function (v) {
            return year.slice(-v.length);
        });
    };
    return BcCalendarUtilities;
}());
exports.BcCalendarUtilities = BcCalendarUtilities;
